export function convertPixelsToMillimeters(numberInPx: number, dpi: number): number {
  return (numberInPx * 26.4583) / dpi;
}
